import { useEffect, useState } from "react"
import { subscribeToUpdates } from "../utils/serviceWorkerUpdates"

/**
 * `{ registration, sequence }` once a newly deployed service worker has
 * finished installing and is waiting to take this page over, or null while the
 * running build is still the current one.
 *
 * The announcement comes from serviceWorker.register()'s `onUpdate` callback in
 * index.js, which runs outside React and may fire before this component ever
 * mounts. utils/serviceWorkerUpdates.js latches it for exactly that reason, so
 * subscribing late is safe.
 *
 * The `sequence` matters: the browser returns the same registration object for
 * the scope on every update, so it is the only way to tell a second deploy from
 * the first.
 */
const useUpdateAvailable = () => {
	const [announcement, setAnnouncement] = useState(null)

	useEffect(() => subscribeToUpdates(update => setAnnouncement(update)), [])

	return announcement
}

export default useUpdateAvailable
